import { render, staticRenderFns } from "./AegAddTransaction.vue?vue&type=template&id=267f2e0b"
import script from "./AegAddTransaction.vue?vue&type=script&lang=js"
export * from "./AegAddTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports